import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import LanguageIcon from '@material-ui/icons/Language';
import { withTranslation } from 'react-i18next';
import MenuItem from "@material-ui/core/MenuItem/MenuItem";

const languages = ['en', 'pl', 'uk', 'ru', 'es', 'de', 'cz'];

class LanguageMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      open: false
    };
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMenuItemClick = (event, code) => {
    this.setState({ open: false });
    this.props.i18n.changeLanguage(code);
  };

  render() {
    return (
      <div>
        <Button
          aria-owns={this.state.open ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          data-cy="language.button"
        >
          <LanguageIcon/>
          {this.props.i18n.resolvedLanguage}
        </Button>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleClose}
          data-cy="language.menu"
        >
        {languages.map((code) => (
          <MenuItem
            key={code}
            onClick={event => this.handleMenuItemClick(event, code)}
          >
            {code.toUpperCase()}
          </MenuItem>
         ))
        }
        </Menu>
      </div>
    );
  }
}

export default withTranslation()(LanguageMenu);
